<script setup>
// Imports
import { computed } from 'vue'
import JsonEditor from 'vue3-ts-jsoneditor'

// Component props
const value = defineModel({ type: [Object, Array, null], required: true })

const textValue = computed({
  get() {
    if (value.value === null || value.value === undefined) return ''
    try {
      return JSON.stringify(value.value, null, 2)
    } catch {
      return ''
    }
  },
  set(text) {
    const t = String(text ?? '').trim()
    if (!t) {
      value.value = null
      return
    }

    try {
      value.value = JSON.parse(t)
    } catch {
      return
    }
  },
})
</script>

<template>
  <div class="json-editor-wrap">
    <json-editor
      v-model:text="textValue"
      :main-menu-bar="false"
      :navigation-bar="false"
      :status-bar="false"
      mode="text"
      v-bind="$attrs"
      class="awesome-json-editor full-width"
      :class="{ 'cursor-not-allowed pointer-events-disabled readonly': $attrs['read-only'] }"
    />
  </div>
</template>

<style lang="scss">
/* Zorgt dat alleen de inhoud scrollt */
.jse-text-mode {
  max-height: 50vh; // 12 “line-heights” (werkt mooi voor “max lines” gevoel)
  overflow: hidden !important; // voorkomt dubbel scrollen
}

.jse-text-mode,
.jse-contents {
  border-top-left-radius: 4px !important;
  border-top-right-radius: 4px !important;
  &--disabled {
    border-style: inherit;
  }
}
.jse-status-bar {
  border-bottom-left-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
  &--disabled {
    border-style: inherit;
  }
}

.cm-panels,
.cm-panels-top {
  display: none !important;
}
</style>
